import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FormArray } from '@angular/forms';
import { FormErrorsConditionOperator } from 'common';
import { FormDetailsActionsService } from '../../services/actions/form-details-actions.service';
import { FormDetailsSectionHeaderConfig, FormDetailsSectionHeaderIconType } from '../form-details-section-header/form-details-section-header.model';
import { ownersSectionHeaderConfig } from '../../form-details.data';
import { MatExpansionPanel } from '@angular/material/expansion';

@UntilDestroy()
@Component({
    selector: 'ifbp-owner-information-form',
    templateUrl: './owner-information-form.component.html',
    styleUrls: ['./owner-information-form.component.scss'],
    standalone: false
})
export class OwnerInformationFormComponent implements OnInit {
  @ViewChild('panel') panel: MatExpansionPanel;

  @Input()
  form: FormArray;

  readonly maxNumberOfOwners = 4;
  readonly maxOwnerAge = 100;
  readonly minOwnerAge = 18;

  readonly ConditionOperator = FormErrorsConditionOperator;
  readonly IconType = FormDetailsSectionHeaderIconType;
  headerConfig: FormDetailsSectionHeaderConfig = ownersSectionHeaderConfig;
  canMarkInvalidSection: boolean;

  minDate: Date;
  maxDate: Date;

  constructor(private readonly formDetailsActions: FormDetailsActionsService) {
    const today = new Date();
    this.minDate = new Date(today);
    this.minDate.setFullYear(this.minDate.getFullYear() - this.maxOwnerAge);
    this.maxDate = new Date(today);
    this.maxDate.setFullYear(this.maxDate.getFullYear() - this.minOwnerAge);
  }

  ngOnInit(): void {
    this.initActions()
  }

  private initActions(): void {
    this.formDetailsActions.markInvalidSections$
      .pipe(untilDestroyed(this))
      .subscribe((canMarkAsInvalid: boolean) => {
        this.canMarkInvalidSection = canMarkAsInvalid;
        if (canMarkAsInvalid && this.form.invalid) {
          this.panel.open();
        }
      })
    this.formDetailsActions.expandAllSections$
      .pipe(untilDestroyed(this))
      .subscribe(() => this.panel.open());
  }

  addOwner(): void {
    this.formDetailsActions.addOwner();
  }

  removeOwner(index: number): void {
    this.formDetailsActions.removeOwner(index);
  }
}
